module.exports = __webpack_public_path__ + "static/media/diamondSusp.b891563e.svg";